// Login Actions
export const SET_START_TIME = 'SET_START_TIME';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_PASSWORD = 'SET_PASSWORD';
export const TOGGLE_HAS_SELECTED_STAY_LOGGED_IN = 'TOGGLE_HAS_SELECTED_STAY_LOGGED_IN';
export const SET_ERROR_TEXT = 'SET_ERROR_TEXT';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const LOGGED_IN_CHECK_REQUEST = 'LOGGED_IN_CHECK_REQUEST';
export const LOGGED_IN_CHECK_SUCCESS = 'LOGGED_IN_CHECK_SUCCESS';
export const LOGGED_IN_CHECK_FAILURE = 'LOGGED_IN_CHECK_FAILURE';

// Password Recovery Actions
export const SET_EMAIL = 'SET_EMAIL';
export const RECOVERY_EMAIL_REQUEST = 'RECOVERY_EMAIL_REQUEST';
export const RECOVERY_EMAIL_SUCCESS = 'RECOVERY_EMAIL_SUCCESS';
export const RECOVERY_EMAIL_FAILURE = 'RECOVERY_EMAIL_FAILURE';

// Registration Actions
export const CREATE_ACCOUNT_REQUEST = 'CREATE_ACCOUNT_REQUEST';
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const CREATE_ACCOUNT_FAILURE = 'CREATE_ACCOUNT_FAILURE';
export const SET_COUNTRY_REQUEST = 'SET_COUNTRY_REQUEST';
export const SET_COUNTRY_BY_LOCATION_API = 'SET_COUNTRY_BY_LOCATION_API';
export const SET_COUNTRY_FAILURE = 'SET_COUNTRY_FAILURE';
export const SET_EULA_LINK = 'SET_EULA_LINK';
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const SET_EULA_LINK_SUCCESS = 'SET_EULA_LINK_SUCCESS';
export const SET_EULA_LINK_FAILURE = 'SET_EULA_LINK_FAILURE';
export const SET_REGISTRATION_EMAIL = 'SET_REGISTRATION_EMAIL';
export const SET_EMAIL_ERROR_TEXT = 'SET_EMAIL_ERROR_TEXT';
export const SET_FIRST_NAME = 'SET_FIRST_NAME';
export const SET_LAST_NAME = 'SET_LAST_NAME';
export const SET_MISSING_ERROR_TEXT = 'SET_MISSING_ERROR_TEXT';
export const SET_REGISTRATION_PASSWORD = 'SET_REGISTRATION_PASSWORD';
export const SET_PASSWORD_ERROR_TEXT = 'SET_PASSWORD_ERROR_TEXT';
export const SET_PHONE_NUMBER_ERROR_TEXT = 'SET_PHONE_NUMBER_ERROR_TEXT';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const TOGGLE_EULA_ACCEPTANCE = 'TOGGLE_EULA_ACCEPTANCE';
export const TOGGLE_SHOW_PASSWORD = 'TOGGLE_SHOW_PASSWORD';

// Reset Password Actions
export const SET_EMAIL_AND_PASSWORD = 'SET_EMAIL_AND_PASSWORD';
export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';
export const SET_PASSWORD_CONFIRM = 'SET_PASSWORD_CONFIRM';
export const VALIDATE_CREATE_PASSWORD = 'VALIDATE_CREATE_PASSWORD';
export const CREATE_PASSWORD_REQUEST = 'CREATE_PASSWORD_REQUEST';
export const CREATE_PASSWORD_SUCCESS = 'CREATE_PASSWORD_SUCCESS';
export const CREATE_PASSWORD_FAILURE = 'CREATE_PASSWORD_FAILURE';
export const CREATE_PASSWORD_REDIRECT = 'CREATE_PASSWORD_REDIRECT';

// Support Info Actions
export const SET_LANDING_PAGE_URLS = 'SET_LANDING_PAGE_URLS';
export const SET_SUPPORT_INFO = 'SET_SUPPORT_INFO';

// Verification Actions
export const VERIFY_USER_REQUEST = 'VERIFY_USER_REQUEST';
export const VERIFY_USER_SUCCESS = 'VERIFY_USER_SUCCESS';
export const VERIFY_USER_FAILURE = 'VERIFY_USER_FAILURE';

// Redirection Actions
export const REDIRECT_USER = 'REDIRECT_USER';
